import history from "./history";

const hidingPath = [];

export const hideBanner = () => {
  let pathPage = history.location.pathname.split("/");
  return hidingPath.includes(pathPage[1]);
};
